import GoCheck from '@meronex/icons/go/GoCheck';
import icon from './StyledIcon';
export default icon(GoCheck);
